import { Injectable } from '@angular/core';
import { ApiService } from './api';

@Injectable({ providedIn: 'root' })
export class ExtractService {

    constructor(private api: ApiService) {}

    getUrlDetails(url) {
        return this.api.get('/ws/extract', this.api.paramify({url}));
    }
}